import { cloneDeep } from '@apollo/client/utilities'
import { produce } from 'immer'

// Mutations
import { Mutations, _mutations } from 'lib/core/services/magento/mutations'
import { AddConfigurableProductToCartMutation, createAddConfigurableProductToCartMutation } from 'lib/core/services/magento/mutations/addConfigurableProductsToCart'
import { AddGiftcardProductToCartMutation, createAddGiftcardProductToCartMutation } from 'lib/core/services/magento/mutations/addGiftcardProductsToCart'
import { AddSimpleProductToCartMutation, createAddSimpleProductToCartMutation } from 'lib/core/services/magento/mutations/addSimpleProductsToCart'
import { AddWishlistItemMutation, createAddWishlistItemMutation } from 'lib/core/services/magento/mutations/addWishlistItem'
import { ApplyCouponToCartMutation, createApplyCouponToCartMutation } from 'lib/core/services/magento/mutations/applyCouponToCart'
import { ApplyGiftCardToCartMutation, createApplyGiftCardToCartMutation } from 'lib/core/services/magento/mutations/applyGiftCardToCart'
import { CreateCustomerMutation, createCreateCustomerMutation } from 'lib/core/services/magento/mutations/createCustomer'
import { CreateAccountMutation, createCreateAccountMutation } from 'lib/core/services/magento/mutations/createAccount'
import { CreateCustomerAddressMutation, createCreateCustomerAddressMutation } from 'lib/core/services/magento/mutations/createCustomerAddress'
import { CreateCustomerCartMutation, createCreateCustomerCartMutation } from 'lib/core/services/magento/mutations/createCustomerCart'
import { GetCreateEmptyCartMutation, createEmptyCartMutation } from 'lib/core/services/magento/mutations/createEmptyCart' // TODO: Rename Type
import { CustomerPasswordMutation, createCustomerPasswordMutation } from 'lib/core/services/magento/mutations/customerPassword' // TODO: Rename Type
import { DeleteCustomerAddressMutation, createDeleteCustomerAddressMutation } from 'lib/core/services/magento/mutations/deleteCustomerAddress'
import { GenerateCustomTokenMutation, createGenerateCustomTokenMutation } from 'lib/core/services/magento/mutations/generateCustomerToken'
import { PlaceGuestOrderMutation, createPlaceGuestOrderMutation } from 'lib/core/services/magento/mutations/placeGuestOrder'
import { PlaceMineOrderMutation, createPlaceMineOrderMutation } from 'lib/core/services/magento/mutations/placeMineOrder'
import { PlaceOrderMutation, createPlaceOrderMutation } from 'lib/core/services/magento/mutations/placeOrder'
import { RemoveCouponFromCartMutation, createRemoveCouponFromCartMutation } from 'lib/core/services/magento/mutations/removeCouponFromCart'
import { RemoveGiftCardFromCartMutation, createRemoveGiftCardFromCartMutation } from 'lib/core/services/magento/mutations/removeGiftCardFromCart'
import { RemoveItemFromCartMutation, createRemoveItemFromCartMutation } from 'lib/core/services/magento/mutations/removeItemFromCart'
import { RemoveWishlistItemMutation, createRemoveWishlistItemMutation } from 'lib/core/services/magento/mutations/removeWishlistItem'
import { ResetPasswordMutation, createResetPasswordMutation } from 'lib/core/services/magento/mutations/resetPassword'
import { SetBillingAddressOnCartMutation, createSetBillingAddressOnCartMutation } from 'lib/core/services/magento/mutations/setBillingAddressOnCart'
import { SetGuestEmailOnCartMutation, createSetGuestEmailOnCartMutation } from 'lib/core/services/magento/mutations/setGuestEmailOnCart'
import { SetShippingAddressesOnCartMutation, createSetShippingAddressesOnCartMutation } from 'lib/core/services/magento/mutations/setShippingAddressesOnCart'
import { SetShippingMethodOnCartMutation, createSetShippingMethodOnCartMutation } from 'lib/core/services/magento/mutations/setShippingMethodsOnCart'
import { SubscribeMutation, createSubscribeMutation } from 'lib/core/services/magento/mutations/subscribe'
import { UpdateCartItemMutation, createUpdateCartItemMutation } from 'lib/core/services/magento/mutations/updateCartItems'
import { UpdateCustomerAddressMutation, createUpdateCustomerAddressMutation } from 'lib/core/services/magento/mutations/updateCustomerAddress'
import { VisitureAddGiftMessageMutation, createVisitureAddGiftMessageMutation } from 'lib/core/services/magento/mutations/visitureAddGiftMessage'
import { SetExtraDataOnCartMutation, createSetExtraDataOnCartMutation } from 'lib/core/services/magento/mutations/setExtraDataOnCart'

// Queries // TODO: define type name pattern, then rename
import { Queries, _queries } from 'lib/core/services/magento/queries'
import { CartQuery, createCartQuery } from 'lib/core/services/magento/queries/cart'
import { GetCmsBlockQuery, createCmsBlocksQuery } from 'lib/core/services/magento/queries/cmsBlocks'
import { GetCmsPageQuery, createCmsPageQuery } from './queries/cmsPage'
import { CountriesQuery, createCountriesQuery } from 'lib/core/services/magento/queries/countries'
import { CountryQuery, createCountryQuery } from 'lib/core/services/magento/queries/country'
import { GetCustomerQuery, createCustomerQuery } from 'lib/core/services/magento/queries/customer'
import { GetCustomerOrdersQuery, createCustomerOrdersQuery } from 'lib/core/services/magento/queries/customerOrders'
import { GetCustomerPaymentTokensQuery, createCustomerPaymentTokensQuery } from 'lib/core/services/magento/queries/customerPaymentTokens'
import { GetCategoryListQuery, createGetCategoryListQuery } from 'lib/core/services/magento/queries/getCategoryList'
import { GetCheckoutConfigQuery, createGetCheckoutConfigQuery } from 'lib/core/services/magento/queries/getCheckoutConfig'
import { GetCmsPagesQuery, createGetCmsPagesQuery } from 'lib/core/services/magento/queries/getCmsPages'
import { GetProductsAttributeListQuery, createGetProductsAttributeListQuery } from 'lib/core/services/magento/queries/getProductAttributeList'
import { PostCategoriesQuery, createPostCategoriesQuery } from 'lib/core/services/magento/queries/postCategories'
import { PostsQuery, createPostsQuery } from 'lib/core/services/magento/queries/posts'
import { GetProductsQuery, createProductsQuery } from 'lib/core/services/magento/queries/products'
import { GetRefreshCustomerToken, createRefreshCustomerToken } from 'lib/core/services/magento/queries/refreshCustomerToken'
import { StoreConfigQuery, createStoreConfigQuery } from 'lib/core/services/magento/queries/storeConfig'
import { UrlResolverQuery, createUrlResolverQuery } from 'lib/core/services/magento/queries/urlResolver'
import { GetValidateResetPasswordLinkTokenQuery, createValidateResetPasswordLinkToken } from 'lib/core/services/magento/queries/validateResetPasswordLinkToken'
import { GetCartGiftMessageQuery, createGetCartGiftMessageQuery } from 'lib/core/services/magento/queries/visitureGetCartGiftMessage'
import { GetVisitureInstagramPostsQuery, createVisitureInstagramPostsQuery } from 'lib/core/services/magento/queries/visitureInstagramPost'
import { GetVisitureProductsQuery, createVisitureProductsQuery } from 'lib/core/services/magento/queries/visitureProducts'
import { GetWishlistQuery, createWishlistQuery } from 'lib/core/services/magento/queries/wishlist'
import {
  createCustomerValidationQuery,
  GetCustomerValidationQuery
} from 'lib/core/services/magento/queries/validateCustomer'

export class Magento {
  private queries: Queries
  private mutations: Mutations
  private client: undefined | MagentoClient

  constructor () {
    this.queries = cloneDeep(_queries)
    this.mutations = cloneDeep(_mutations)
  }

  private getDeps (): ServiceDependencies {
    return {
      getQueries: () => JSON.parse(JSON.stringify(this.queries)),
      getMutations: () => JSON.parse(JSON.stringify(this.mutations))
    }
  }

  public extend (queries?: (queries: Queries) => void, mutations?: (queries: Mutations) => void): void {
    this.queries = queries ? produce(this.queries, queries) : this.queries
    this.mutations = mutations ? produce(this.mutations, mutations) : this.mutations
  }

  getClient (): MagentoClient {
    if (this.client) {
      return this.client
    }

    const deps = this.getDeps()
    this.client = {
      cms: {
        fetchPageList: createGetCmsPagesQuery(deps),
        getCmsPage: createCmsPageQuery(deps),
        fetchCmsBlock: createCmsBlocksQuery(deps),
        fetchInstagramFeed: createVisitureInstagramPostsQuery(deps)
      },
      catalog: {
        fetchProductListPage: createVisitureProductsQuery(deps),
        fetchCategoryList: createGetCategoryListQuery(deps),
        fetchProduct: createProductsQuery(deps),
        fetchProductAttributeList: createGetProductsAttributeListQuery(deps)
      },
      customer: {
        me: createCustomerQuery(deps),
        getCustomerValidation: createCustomerValidationQuery(deps),
        createCustomerCart: createCreateCustomerCartMutation(deps),
        createAccount: createCreateAccountMutation(deps),
        createCustomer: createCreateCustomerMutation(deps),
        token: createGenerateCustomTokenMutation(deps),
        tokenRefresh: createRefreshCustomerToken(deps),
        resetPasswordEmail: createCustomerPasswordMutation(deps),
        checkResetPasswordToken: createValidateResetPasswordLinkToken(deps),
        resetPassword: createResetPasswordMutation(deps),
        subscribe: createSubscribeMutation(deps),
        createCustomerAddress: createCreateCustomerAddressMutation(deps),
        editCustomerAddress: createUpdateCustomerAddressMutation(deps),
        deleteCustomerAddress: createDeleteCustomerAddressMutation(deps),
        addProductToWishlist: createAddWishlistItemMutation(deps),
        removeWishlistItem: createRemoveWishlistItemMutation(deps),
        fetchWishlist: createWishlistQuery(deps),
        fetchOrders: createCustomerOrdersQuery(deps),
        paymentTokens: createCustomerPaymentTokensQuery(deps)
      },
      quote: {
        createEmptyCart: createEmptyCartMutation(deps),
        addSimpleProduct: createAddSimpleProductToCartMutation(deps),
        addGiftCardProduct: createAddGiftcardProductToCartMutation(deps),
        addConfigurableProduct: createAddConfigurableProductToCartMutation(deps),
        fetchCart: createCartQuery(deps),
        updateCartItems: createUpdateCartItemMutation(deps),
        removeCartItems: createRemoveItemFromCartMutation(deps),
        couponApply: createApplyCouponToCartMutation(deps),
        couponRemove: createRemoveCouponFromCartMutation(deps),
        giftCardApply: createApplyGiftCardToCartMutation(deps),
        giftCardRemove: createRemoveGiftCardFromCartMutation(deps),
        getGiftMessage: createGetCartGiftMessageQuery(deps),
        saveGiftMessage: createVisitureAddGiftMessageMutation(deps),
        setExtraDataOnCart: createSetExtraDataOnCartMutation(deps),
        setGuestEmail: createSetGuestEmailOnCartMutation(deps),
        setShippingAddresses: createSetShippingAddressesOnCartMutation(deps),
        setBillingAddresses: createSetBillingAddressOnCartMutation(deps),
        setShippingMethod: createSetShippingMethodOnCartMutation(deps),
        fetchCheckoutConfig: createGetCheckoutConfigQuery(deps),
        placeGuestOrder: createPlaceGuestOrderMutation(deps),
        placeOrder: createPlaceMineOrderMutation(deps),
        placeOrderNext: createPlaceOrderMutation(deps)
      },
      blog: {
        fetchCategoryList: createPostCategoriesQuery(deps),
        fetchPostList: createPostsQuery(deps)
      },
      directory: {
        fetchCountryInfo: createCountryQuery(deps),
        fetchCountries: createCountriesQuery(deps)
      },
      common: {
        fetchStoreConfig: createStoreConfigQuery(deps),
        urlResolver: createUrlResolverQuery(deps)
      }
    }

    return this.client
  }
}

export const replaceMutation = (query: string, params?: Record<string, any>) => { // TODO remove.
  params && Object.keys(params).forEach(param => {
    query = query.replace(`"%{${param}}"`, params[param])
    query = query.replace(`"string%{${param}}"`, `"${params[param]}"`)
  })

  return query
}

export interface ServiceDependencies {
  getQueries: () => Queries
  getMutations: () => Mutations
}

export interface MagentoClient {
  quote: {
    updateCartItems: UpdateCartItemMutation
    fetchCheckoutConfig: GetCheckoutConfigQuery
    addConfigurableProduct: AddConfigurableProductToCartMutation
    removeCartItems: RemoveItemFromCartMutation
    placeOrder: PlaceMineOrderMutation
    giftCardApply: ApplyGiftCardToCartMutation
    setShippingAddresses: SetShippingAddressesOnCartMutation
    setShippingMethod: SetShippingMethodOnCartMutation
    giftCardRemove: RemoveGiftCardFromCartMutation
    getGiftMessage: GetCartGiftMessageQuery
    saveGiftMessage: VisitureAddGiftMessageMutation
    setExtraDataOnCart: SetExtraDataOnCartMutation
    setBillingAddresses: SetBillingAddressOnCartMutation
    setGuestEmail: SetGuestEmailOnCartMutation
    couponApply: ApplyCouponToCartMutation
    fetchCart: CartQuery
    addSimpleProduct: AddSimpleProductToCartMutation
    addGiftCardProduct: AddGiftcardProductToCartMutation
    createEmptyCart: GetCreateEmptyCartMutation
    placeGuestOrder: PlaceGuestOrderMutation
    placeOrderNext: PlaceOrderMutation
    couponRemove: RemoveCouponFromCartMutation
  }
  common: {
    fetchStoreConfig: StoreConfigQuery
    urlResolver: UrlResolverQuery
  }
  catalog: {
    fetchCategoryList: GetCategoryListQuery
    fetchProduct: GetProductsQuery
    fetchProductListPage: GetVisitureProductsQuery
    fetchProductAttributeList: GetProductsAttributeListQuery
  }
  cms: {
    fetchPageList: GetCmsPagesQuery
    fetchCmsBlock: GetCmsBlockQuery
    fetchInstagramFeed: GetVisitureInstagramPostsQuery
    getCmsPage: GetCmsPageQuery
  }
  blog: {
    fetchCategoryList: PostCategoriesQuery
    fetchPostList: PostsQuery
  }
  directory: {
    fetchCountryInfo: CountryQuery
    fetchCountries: CountriesQuery
  }
  customer: {
    resetPassword: ResetPasswordMutation
    fetchWishlist: GetWishlistQuery
    fetchOrders: GetCustomerOrdersQuery
    subscribe: SubscribeMutation
    createCustomerCart: CreateCustomerCartMutation
    getCustomerValidation: GetCustomerValidationQuery
    addProductToWishlist: AddWishlistItemMutation
    createAccount: CreateAccountMutation
    createCustomer: CreateCustomerMutation
    editCustomerAddress: UpdateCustomerAddressMutation
    token: GenerateCustomTokenMutation
    tokenRefresh: GetRefreshCustomerToken
    removeWishlistItem: RemoveWishlistItemMutation
    me: GetCustomerQuery
    resetPasswordEmail: CustomerPasswordMutation
    createCustomerAddress: CreateCustomerAddressMutation
    deleteCustomerAddress: DeleteCustomerAddressMutation
    checkResetPasswordToken: GetValidateResetPasswordLinkTokenQuery
    paymentTokens: GetCustomerPaymentTokensQuery
  }
}
